import React from 'react';
import { FadeIn } from './Shared';
import { ShieldCheck } from 'lucide-react';
export const Guarantee = () => {
  return <section className="py-6 md:py-10 px-4 bg-navy-900" data-id="element-129">
      <div className="max-w-3xl mx-auto text-center" data-id="element-130">
        <FadeIn data-id="element-131">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gold-500/10 mb-6" data-id="element-132">
            <ShieldCheck className="w-8 h-8 text-gold-400" data-id="element-133" />
          </div>
          <h2 className="text-2xl md:text-3xl font-serif font-bold text-white mb-6" data-id="element-134">
            🛡️ GARANTÍA 7 DÍAS — SIN PREGUNTAS
          </h2>
          <p className="text-lg text-gray-300 mb-8 leading-relaxed" data-id="element-135">
            Abrís los tomos. Los aplicás esa noche. Si en 7 días no ves cambios
            reales: devolución del 100%. Sin formularios. Sin drama.
          </p>
          <div className="inline-block bg-navy-800 px-6 py-3 rounded-full border border-navy-700" data-id="element-136">
            <span className="text-gray-400 font-medium" data-id="element-137">
              Tasa de devoluciones:{' '}
              <span className="text-gold-400 font-bold" data-id="element-138">menos del 1%.</span>
            </span>
          </div>
        </FadeIn>
      </div>
    </section>;
};